import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { MatSelectModule } from '@angular/material/select';
import { SafeHtmlPipe } from './safe-html.pipe';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import localeHi from '@angular/common/locales/hi';
import { lastValueFrom } from 'rxjs';
import { AadharMaskPipe } from './aadhar-mask.pipe';
import { ZoomableElementComponent } from './zoomable-element/zoomable-element.component';
import { PreventCopyDirective } from './prevent-copy.directive';

// import localeGu from '@angular/common/locales/gu';

// translate http loader
export function TranslateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SafeHtmlPipe,
    LanguageSelectorComponent,
    AadharMaskPipe,
    ZoomableElementComponent,
    PreventCopyDirective,
    
  ],
  imports: [
    CoreModule.forRoot(),
    TranslateModule.forRoot({
      loader: { provide: TranslateLoader, useFactory: TranslateHttpLoaderFactory, deps: [HttpClient]}
    }),
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    BrowserAnimationsModule,
    LayoutModule,
    BsDatepickerModule.forRoot(),
  ],
  providers: [],
  exports: [SafeHtmlPipe],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor() {
    registerLocaleData(localeHi, 'hi');
    // registerLocaleData(localeGu, 'gu');
  }
}
